import PhotoCategory from ".";


export const photoCategoryRoutes = () => [
  {
    path: "/admin/photo-categories",
    component: PhotoCategory,
    layout: "admin",
    routeType: "admin",
    title: "Photo Management",
  },
];
